import { Tooltip, Icon } from "antd";
import React from "react";
import './InfoQuestion.less';

interface IInfoQuestionProps {
    title: string;
}
interface IInfoQuestionState {
    visible: boolean;
}

export class InfoQuestion extends React.Component<IInfoQuestionProps, IInfoQuestionState> {

    constructor(props: IInfoQuestionProps) {
        super(props);
        this.state = {
            visible: false
        }
    }

    public toggleVisibility = () => {
        this.setState({ visible: !this.state.visible })
    }

    render() {
        return (
            <Tooltip onVisibleChange={this.toggleVisibility} visible={this.state.visible} mouseEnterDelay={.75} placement="rightTop" title={this.props.title}>
                <Icon onClick={this.toggleVisibility} className="info-question" type="question-circle" />
            </Tooltip>
        );
    }
}
